import React, { useState } from 'react';

import MessageModal from '../../molecules/MessageModal';
import { Strings } from '../../../shared/constants/Constants';

const ScreenTitle = ({ title, subTitle = '' }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      {openModal && (
        <MessageModal
          icon='email.png'
          callback={() => setOpenModal(false)}
          render={() => (
            <>
              <h4
                style={{
                  fontWeight: 400,
                  color: '#778391',
                }}
              >
                {Strings.emailsAt}
              </h4>
              <p
                style={{
                  fontSize: 20,
                  textDecoration: 'underline',
                  paddingBottom: 5,
                  textDecorationColor: '#747474',
                }}
              >
                <a
                  href='mailto:trainer@diehl1.com'
                  style={{ color: '#242424' }}
                >
                  trainer@diehl1.com
                </a>
                {/* trainer@diehl1.com */}
              </p>
            </>
          )}
        />
      )}
      <div className='hd-title d-flex align-items-center'>
        <h4>
          {title}
          {subTitle !== '' && (
            <span>&nbsp; {subTitle ? `   > ${subTitle}` : null}</span>
          )}
          <i>
            <img
              src={require('../../../Assets/Images/Icons/info_icon.png')}
              alt=''
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenModal(true)}
            />
          </i>
        </h4>
      </div>
    </>
  );
};

export default ScreenTitle;
